export default __webpack_public_path__ + "static/media/david-marcu.9f5583c3.jpg";